import React, { useState } from "react";
import { RichEditorStyledButton } from "./RichTextControlStyles";

export interface IStyleButtonProps {
  onToggle: any;
  style: any;
  active: boolean;
  label: string;
}

const StyleButton: React.FC<IStyleButtonProps> = (props) => {
  const [isActive, setIsActive] = useState<boolean>(false);

  const onToggle = (e: any) => {
    e.preventDefault();
    setIsActive(!isActive);
    props.onToggle(props.style);
  };

  return (
    <RichEditorStyledButton IsActive={isActive} onMouseDown={onToggle}>
      {props.label}
    </RichEditorStyledButton>
  );
};

export default StyleButton;
